import React, {createContext, useEffect, useRef, useState} from "react";

import useScript from "../utils/useScript";
import {env} from "../properties";


export const UmamiContext = createContext();

const UmamiProvider = props => {
  const alreadyTracking = useRef(false);
  const [umamiAttrs] = useState({"data-website-id": env.umamiWebsiteDataId, "data-auto-track": "false"});
  const scriptPromise = useScript(env.umamiUrl, umamiAttrs);

  useEffect(() => {
    if (scriptPromise && !alreadyTracking.current) {
      scriptPromise.then(() => {
        track();
        alreadyTracking.current = true;
      });
    }
  }, [scriptPromise]);

  const track = (...args) => {
    if (window.umami) {
      args[1] = args[1] || {};
      window.umami.track(props => ({
        ...props,
        url: 'registration',
        name: args[0],
        data: args[1]
      }));
    }

  };

  const provider = {
    track
  };

  return (
    <UmamiContext.Provider value={provider}>
      {props.children}
    </UmamiContext.Provider>
  );
};

export default UmamiProvider;

